import { formatBRL, formatNumber } from '@/lib/format';
import type { RankingMetric } from '@/lib/types';

export const receiptsLabel = (count: number) => `${formatNumber(count)} ${count === 1 ? 'comprovante' : 'comprovantes'}`;

export const salesLabel = (count: number) => `${formatNumber(count)} ${count === 1 ? 'venda' : 'vendas'}`;

/** O valor de uma métrica do jeito que se lê: quantidade ou dinheiro. */
export const formatMetric = (metric: RankingMetric, value: number) =>
  metric === 'count' ? receiptsLabel(value) : formatBRL(value);
